import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { itemsPerPage } from 'bundles/directory-graphql/common/constants';
import type { MetaNameAndPropertiesProps } from 'bundles/seo/CourseraMetatagsV2Types';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

type Props = {
  total: number;
  additionalSettings: MetaNameAndPropertiesProps;
};

const MetatagsWithPagination = ({ total, additionalSettings }: Props) => {
  const pageCount = Math.ceil(total / itemsPerPage);
  const {
    location: {
      hostname,
      pathname,
      query: { page },
    },
  } = useRouter();
  const currentPage = page ? parseInt(page, 10) : 1;
  const paginationHref: any = {};
  if (currentPage > 1) {
    paginationHref.prevPageHref = `https://${hostname}${pathname}?page=${currentPage - 1}`;
  }
  if (currentPage < pageCount) {
    paginationHref.nextPageHref = `https://${hostname}${pathname}?page=${currentPage + 1}`;
  }

  return <CourseraMetatags metaNameAndProperties={additionalSettings} {...paginationHref} />;
};

export default MetatagsWithPagination;
